import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconCrown, IconWallet, IconCar } from './icons';
import { Reveal } from './Reveal';
import { Tilt3D } from './Tilt3D';
const ITEMS = [{
  icon: IconCrown,
  title: 'trust.1.title',
  desc: 'trust.1.desc'
}, {
  icon: IconWallet,
  title: 'trust.2.title',
  desc: 'trust.2.desc'
}, {
  icon: IconCar,
  title: 'trust.3.title',
  desc: 'trust.3.desc'
}];
export function TrustBar() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="trust-heading" className="w-full bg-offwhite" data-id="element-407" data-mp="1uyq5no5f0518">
      <h2 id="trust-heading" className="sr-only" data-id="element-408" data-mp="1uwvs4uwh3f76">
        {t('exp.eyebrow')}
      </h2>
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-12 sm:px-6 md:grid-cols-3 md:gap-10" data-id="element-409" data-mp="1gyytlsygkypv">
        {ITEMS.map((item, index) => {
        const Icon = item.icon;
        return <Reveal key={item.title} delay={index * 0.08} data-id="element-410" data-mp="5melcswaqdtz" data-mpi={index}>
              <Tilt3D max={6} lift={10} data-id="element-411" data-mp="ajxytql66mkv">
                <div className="flex items-start gap-4" data-id="element-412" data-mp="agsa4cggdmpo">
                  <Icon className="mt-0.5 h-7 w-7 shrink-0 text-camelink" data-id="element-413" data-mp="1ajordvd1b22b" />
                  <div data-id="element-414" data-mp="16i3jkofcxdyz">
                    <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-415" data-mp="16in0c1t9twbf">
                      {t(item.title)}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-416" data-mp="1fhqmjenqiru5">{t(item.desc)}</p>
                  </div>
                </div>
              </Tilt3D>
            </Reveal>;
      })}
      </div>
    </section>;
}